var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jTabsa" }, [
    _c(
      "div",
      { staticClass: "tab-content", attrs: { id: "tab-container" } },
      _vm._l(_vm.tabs, function(item) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "tab-pane",
            attrs: {
              id: item.idComp,
              "aria-labelledby": item.idTab,
              role: "tabpanel"
            }
          },
          [
            _vm.isLoadTab(item.idTab)
              ? _c(item.comp, {
                  tag: "component",
                  staticClass: "tab-component"
                })
              : _vm._e()
          ],
          1
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb21c072", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb21c072","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/jTabs.vue
// module id = null
// module chunks = 